// Removes the "paper" from a photo or scan of a signature so only the ink remains.
// Same idea as the server-side cleaner (server/services/signatureImage.service.js):
// the paper colour is the median luminance of the image border, anything close to it
// becomes transparent, anything clearly darker stays opaque, with a smooth ramp between
// so edges are soft instead of jagged. Images that already have transparency are left
// alone.

const lum = (d, i) => 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];

// Returns a new canvas; `source` is not modified.
export function removeSignatureBackground(source) {
  const { width, height } = source;
  const out = document.createElement('canvas');
  out.width = width;
  out.height = height;
  const ctx = out.getContext('2d');
  ctx.drawImage(source, 0, 0);
  const img = ctx.getImageData(0, 0, width, height);
  const d = img.data;

  for (let i = 3; i < d.length; i += 4) {
    if (d[i] < 250) return out;   // already transparent: nothing to remove
  }

  const band = Math.max(2, Math.round(Math.min(width, height) * 0.03));
  const step = Math.max(1, Math.floor(Math.max(width, height) / 200));
  const samples = [];
  for (let y = 0; y < height; y += step) {
    for (let x = 0; x < width; x += step) {
      if (x < band || y < band || x >= width - band || y >= height - band) samples.push(lum(d, (y * width + x) * 4));
    }
  }
  samples.sort((a, b) => a - b);
  const paper = samples[Math.floor(samples.length / 2)] ?? 255;

  const lo = 14;
  const hi = Math.max(60, Math.min(110, paper * 0.45));
  for (let i = 0; i < d.length; i += 4) {
    const t = Math.min(1, Math.max(0, (paper - lum(d, i) - lo) / (hi - lo)));
    d[i + 3] = Math.round(t * t * (3 - 2 * t) * 255);
  }
  ctx.putImageData(img, 0, 0);
  return out;
}
